import type { ITemplateUser } from "~/interfaces";

export default function MainTitle({
	title = "",
}: ITemplateUser) {
	return title ? <h1>{ title }</h1> : null;
}
